// src/dashboard/utils/themesmap.js

// Mappa: ID del tema nel DB  ->  chiave usata in i18n (themes.xxx)
export const THEME_KEY_BY_ID = {
  20: "market_analysis",
  21: "marketing_branding",
  22: "sensory_psychology",
  23: "sustainability_climate",
  24: "innovation_tech_digital",
  25: "governance_strategy",
  26: "finance_investment",
  27: "human_capital",
  28: "wine_tourism",
  29: "landscape_territory",
  30: "history_culture",
  31: "regulation_policy",
  32: "supply_chain",
  33: "social_sustainability",
  34: "education_training",
};

// 🔹 AGGIUNGI QUESTO BLOCCO:
export const THEME_LABELS = {
  market_analysis:
    "Global and Domestic Market Analysis, Competitiveness, and Trade",
  marketing_branding: "Marketing, Branding, and Advertising",
  sensory_psychology: "Sensory, Consumer Psychology, and Linguistics",
  sustainability_climate:
    "Sustainability, Climate, and Environmental Transitions",
  innovation_tech_digital:
    "Innovation, Technology, and Digital Transformation",
  governance_strategy: "Governance, Strategy, and Business Models",
  finance_investment: "Finance, Investment, and Risk Management",
  human_capital: "Human Capital, Labor, and Firm Capabilities",
  wine_tourism: "Wine Tourism, Hospitality, and Culinary Arts",
  landscape_territory:
    "Landscape, Territorial Development & Regional Ecosystems",
  history_culture:
    "History, Culture, Heritage, and the Symbolic Value of Wine",
  regulation_policy: "Regulation, Policy, and Institutional Frameworks",
  supply_chain: "Supply Chain and Distribution",
  social_sustainability:
    "Social Sustainability, Ethics, and Worker Rights",
  education_training:
    "Wine Education, Professional Training, and Knowledge Transfer",
};

// Funzione helper: prende l’oggetto theme e restituisce la chiave giusta
export const getThemeKey = (theme) => {
  if (!theme) return "market_analysis";

  // prova a leggere theme.id o theme.theme_id
  const rawId = theme.id ?? theme.theme_id;
  if (rawId == null) return "market_analysis";

  const id = String(rawId).trim(); // "20", "21", ...
  return THEME_KEY_BY_ID[id] || "market_analysis";
};
